module.exports = __webpack_public_path__ + "img/3.344a9594.png";